export const SEARCH_WITH_CLIENT = `
query ($location_id: [ID!], $start_date: String!, $include_client: Boolean) {
  appointmentSearch (location_id: $location_id, start_date: $start_date, include_client: $include_client) {
    id,
    location_id,
    appointmentDate,
    status,
    waitingDate,
    seatedDate,
    completedDate,
    checkedOutDate,
    appointmentType,
    client {
      id,
      firstName,
      lastName,
      nickName,
      phone,
      email,
      completedAppointments
    }
  }
}
`

export const SEARCH = `
query ($location_id: [ID!], $start_date: String!) {
  appointmentSearch (location_id: $location_id, start_date: $start_date) {
    id,
    location_id,
    appointmentDate,
    status,
    waitingDate,
    seatedDate,
    completedDate,
    checkedOutDate,
  }
}
`
